import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SchemaOrg, { getBreadcrumbSchema, getWebPageSchema, getFAQSchema, getOrganizationSchema } from '@/components/feature/SchemaOrg';
import { Link } from 'react-router-dom';

const aboutFaqs = [
  { question: '韩漫漫画网是免费的吗？', answer: '是的！韩漫漫画网所有漫画均为免费在线阅读，无需付费即可畅享海量韩漫资源。我们通过广告收入维持运营，持续为用户提供优质的免费阅读体验。' },
  { question: '如何找到我想看的漫画？', answer: '您可以通过顶部的分类导航浏览不同题材的漫画，也可以使用搜索功能直接查找。我们的智能推荐系统还会根据您的阅读历史推送个性化内容。' },
  { question: '漫画多久更新一次？', answer: '热门漫画通常每周更新一到两次，部分作品与韩国同步更新。您可以在漫画详情页查看具体的更新频率和最新话数。' },
  { question: '支持手机阅读吗？', answer: '完全支持！韩漫漫画网采用响应式设计，完美适配手机、平板和电脑等多种设备。下拉式阅读方式在手机上体验特别流畅。' },
  { question: '如何联系客服或商务合作？', answer: '您可以通过邮箱 hello@linxituan.com 或电话 +86 400-888-6666 联系我们。商务合作、内容投稿也可通过这些方式沟通。' },
];

export default function About() {
  return (
    <>
      <SchemaOrg type="Organization" data={getOrganizationSchema()} />
      <SchemaOrg type="WebPage" data={getWebPageSchema(
        '关于我们 - 韩漫漫画网',
        '了解韩漫漫画网品牌故事、核心优势与联系方式。500万+注册用户信赖的免费韩国漫画在线阅读平台。',
        'http://linxituan.com/about'
      )} />
      <SchemaOrg type="BreadcrumbList" data={getBreadcrumbSchema([
        { name: '首页', url: 'http://linxituan.com/' },
        { name: '关于我们', url: 'http://linxituan.com/about' },
      ])} />
      <SchemaOrg type="FAQPage" data={getFAQSchema(aboutFaqs)} />
      <Navbar />
      <main className="pt-16">
        <div className="max-w-5xl mx-auto px-4 md:px-6 py-8">
          <nav className="flex items-center gap-2 text-sm text-foreground-500 mb-8" aria-label="面包屑导航">
            <Link to="/" className="hover:text-primary-600 cursor-pointer transition-colors">首页</Link>
            <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-s-line text-xs"></i></span>
            <span className="text-foreground-800 font-medium">关于我们</span>
          </nav>

          <div className="text-center mb-16">
            <h1 className="font-heading text-4xl md:text-6xl text-foreground-950 mb-4">
              发现精彩<br />韩漫世界
            </h1>
            <div className="flex justify-center gap-6 my-10">
              {['🎨 精美画风', '📚 海量资源', '🚀 极速更新'].map((label, i) => (
                <div
                  key={label}
                  className="w-32 h-44 rounded-xl bg-gradient-to-br from-primary-300 to-secondary-200 flex items-center justify-center transform"
                  style={{ transform: `rotate(${i * 8 - 8}deg)` }}
                >
                  <span className="font-heading text-sm text-foreground-800 text-center">{label}</span>
                </div>
              ))}
            </div>
            <p className="text-sm text-foreground-600 max-w-lg mx-auto mb-8">韩漫漫画网 - 您的免费韩国漫画在线阅读平台</p>
            <div className="flex items-center justify-center gap-4">
              <Link
                to="/category/romance"
                className="px-8 py-3.5 bg-primary-500 text-white rounded-full text-sm font-semibold whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-all shadow-lg shadow-primary-500/30"
              >
                开始阅读
              </Link>
              <a href="#contact" className="px-8 py-3.5 text-foreground-600 hover:text-primary-600 rounded-full text-sm font-medium whitespace-nowrap cursor-pointer transition-colors border border-foreground-200 hover:border-primary-300">
                联系我们
              </a>
            </div>
          </div>

          <section className="bg-secondary-50/50 rounded-2xl p-8 md:p-12 mb-16">
            <div className="flex flex-col md:flex-row gap-8">
              <div className="md:w-1/4">
                <p className="text-xs font-medium text-foreground-500 mb-2">关于韩漫漫画网</p>
              </div>
              <div className="md:w-3/4">
                <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-6">品牌介绍</h2>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
                  韩漫漫画网成立于2022年，是国内领先的韩国漫画在线阅读平台。我们致力于为中国读者提供最全面、最优质的韩漫阅读体验。平台汇聚超过20000部韩国漫画作品，覆盖恋爱甜宠、热血冒险、悬疑推理、治愈日常、奇幻异界、都市剧情等多元分类，满足不同读者的阅读需求。
                </p>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8">
                  我们采用先进的无遮挡下拉式阅读技术，确保流畅沉浸的阅读体验。智能推荐系统根据您的阅读偏好精准推送个性化内容，帮助您发现更多心仪作品。所有漫画均为正版授权，画质高清，翻译精良。
                </p>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
                  <div>
                    <p className="text-3xl md:text-4xl font-bold text-foreground-900">500万+</p>
                    <p className="text-xs text-foreground-500 mt-1">注册用户</p>
                  </div>
                  <div>
                    <p className="text-3xl md:text-4xl font-bold text-foreground-900">20000+</p>
                    <p className="text-xs text-foreground-500 mt-1">漫画库存</p>
                  </div>
                  <div>
                    <p className="text-3xl md:text-4xl font-bold text-foreground-900">30万+</p>
                    <p className="text-xs text-foreground-500 mt-1">日活跃用户</p>
                  </div>
                  <div>
                    <p className="text-3xl md:text-4xl font-bold text-foreground-900">98.5%</p>
                    <p className="text-xs text-foreground-500 mt-1">用户满意度</p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="mb-16">
            <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 text-center mb-12">🎯 核心优势</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {[
                { title: '极速更新', desc: '与韩国同步更新，第一时间获取最新章节，不用再等翻译。专业翻译团队保障品质。', icon: 'ri-flashlight-line', color: 'from-primary-400 to-primary-600' },
                { title: '高清画质', desc: '所有漫画均提供高清画质，支持多种设备阅读。无论是在手机还是电脑上都能享受极致画面。', icon: 'ri-hd-line', color: 'from-accent-400 to-accent-600' },
                { title: '智能推荐', desc: 'AI算法深度分析您的阅读偏好，精准推荐您可能感兴趣的作品。告别剧荒，发现新喜好。', icon: 'ri-magic-line', color: 'from-secondary-400 to-secondary-600' },
              ].map((item) => (
                <div key={item.title} className="relative rounded-xl overflow-hidden group cursor-pointer" style={{ aspectRatio: '3/4' }}>
                  <div className={`w-full h-full bg-gradient-to-br ${item.color} flex flex-col items-center justify-center p-8 text-center`}>
                    <span className="w-16 h-16 flex items-center justify-center mb-6">
                      <i className={`${item.icon} text-4xl text-white`}></i>
                    </span>
                    <h3 className="font-heading text-2xl text-white mb-3">{item.title}</h3>
                    <p className="text-white/80 text-sm leading-relaxed">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </section>

          <section className="bg-background-100 rounded-2xl p-8 md:p-12 mb-16">
            <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 text-center mb-12">💬 用户口碑</h2>
            <div className="flex flex-col md:flex-row gap-8 items-center">
              <div className="w-48 h-48 md:w-56 md:h-56 flex-shrink-0 rounded-3xl overflow-hidden bg-accent-100">
                <img
                  src="https://readdy.ai/api/search-image?query=Young%20Asian%20woman%20portrait%20happy%20smile%2C%20casual%20modern%20style%2C%20warm%20soft%20lighting%2C%20clean%20minimal%20background%2C%20friendly%20approachable%20expression%2C%20Korean%20beauty%20portrait%20photography&width=400&height=400&seq=about-testi-avatar&orientation=squarish"
                  alt="读者评价"
                  title="韩漫漫画网读者"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex-1">
                <p className="text-xs font-medium text-accent-600 uppercase tracking-wide mb-2">（读者评价）</p>
                <h3 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-6">真心推荐<span className="text-foreground-300">给每个韩漫迷</span></h3>
                <blockquote className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 border-l-3 border-accent-300 pl-5">
                  "用了韩漫漫画网快两年了，真的是我用过最好的韩漫平台。更新快、画质好、分类全，最重要的是免费！智能推荐也特别准，现在每天都要打开看看有没有新漫画。"
                </blockquote>
                <p className="text-sm font-semibold text-foreground-800">— 小美同学，两年资深用户</p>
              </div>
            </div>
          </section>

          <section id="contact" className="bg-secondary-50/50 rounded-2xl p-8 md:p-12 mb-16">
            <div className="flex flex-col md:flex-row gap-8">
              <div className="md:w-1/2">
                <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 mb-4">联系我们</h2>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8">
                  欢迎商务合作、内容投稿、意见建议。我们期待与您一起打造更好的韩漫阅读社区。
                </p>
                <div className="space-y-4">
                  <div className="flex items-center gap-3">
                    <span className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100">
                      <i className="ri-mail-line text-primary-600"></i>
                    </span>
                    <div>
                      <p className="text-xs text-foreground-500">邮箱</p>
                      <p className="text-sm font-medium text-foreground-800">hello@linxituan.com</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-3">
                    <span className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100">
                      <i className="ri-phone-line text-accent-600"></i>
                    </span>
                    <div>
                      <p className="text-xs text-foreground-500">电话</p>
                      <p className="text-sm font-medium text-foreground-800">+86 400-888-6666</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-3">
                    <span className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100">
                      <i className="ri-map-pin-line text-secondary-600"></i>
                    </span>
                    <div>
                      <p className="text-xs text-foreground-500">地址</p>
                      <p className="text-sm font-medium text-foreground-800">中国北京市朝阳区漫画大厦 1008 室</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="md:w-1/2">
                <div className="rounded-xl overflow-hidden" style={{ aspectRatio: '4/3' }}>
                  <img
                    src="https://readdy.ai/api/search-image?query=Modern%20creative%20office%20workspace%20with%20comic%20art%20on%20walls%2C%20colorful%20webtoon%20illustrations%20decor%2C%20warm%20cozy%20atmosphere%2C%20natural%20light%20from%20large%20windows%2C%20creative%20industry%20vibe%2C%20Korean%20manhwa%20studio%20interior%2C%20professional%20photography&width=800&height=600&seq=about-contact-img&orientation=landscape"
                    alt="韩漫漫画网办公环境"
                    title="韩漫漫画网 - 联系我们"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
          </section>

          <section className="mb-16">
            <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 text-center mb-12">❓ 常见问题</h2>
            <div className="max-w-3xl mx-auto space-y-4">
              {aboutFaqs.map((faq, i) => (
                <details key={i} className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden">
                  <summary className="flex items-center justify-between p-5 cursor-pointer hover:bg-background-100 transition-colors">
                    <span className="text-sm font-medium text-foreground-800 pr-4">{faq.question}</span>
                    <span className="w-5 h-5 flex items-center justify-center flex-shrink-0 text-foreground-400 group-open:rotate-180 transition-transform">
                      <i className="ri-arrow-down-s-line"></i>
                    </span>
                  </summary>
                  <div className="px-5 pb-5">
                    <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                  </div>
                </details>
              ))}
            </div>
          </section>
        </div>
      </main>
      <Footer />
    </>
  );
}